import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminReviews = lazy(() => import("@/pages/admin/AdminReviews"));

export const Route = createFileRoute("/admin/betyg")({
  component: () => <AdminReviews />,
});
